"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Exit: the backdrop fades out and the dialog settles down slightly. Applied
// while the modal is dismissing, before it unmounts.
const overlayFadeOut = "x1jn504y-B";
const dialogPopOut = "x1d8j6cx-B";
const styles = exports.styles = {
  dialogScroll: {
    maxHeight: "x5wgyl0",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    $$css: true
  },
  scrollBody: {
    overflowY: "x1odjw0f",
    flexGrow: "x1iyjqo2",
    minHeight: "x2lwn1j",
    $$css: true
  },
  scrollBodyOverflowing: {
    marginBottom: "xat24cr",
    $$css: true
  },
  actionsAfterScroll: {
    paddingTop: "x1mcfnh7",
    borderTopWidth: "x178xt8z",
    borderTopStyle: "x13fuv20",
    borderTopColor: "x1a6tffd",
    $$css: true
  },
  dialogWide: {
    maxWidth: "xclyx6u",
    $$css: true
  },
  accentClose: {
    color: "x19p3n1p x1iih0q2",
    backgroundColor: "xjbqb8w x1lpn5iz",
    borderColor: "xs5ia2r",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    transition: "xc5uhkn",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  overlayOut: {
    animationName: "xxp0q0x",
    animationDuration: "xllfotl x1u6grsq",
    animationTimingFunction: "x1debuo4",
    animationFillMode: "x10e4vud",
    $$css: true
  },
  dialogOut: {
    animationName: "x156jbrk",
    animationDuration: "xllfotl x1u6grsq",
    animationTimingFunction: "x1debuo4",
    animationFillMode: "x10e4vud",
    $$css: true
  }
};